import axios from "axios";
import React, { createContext } from "react";
import { url } from "../constants/urls.js";
import Cookies from "universal-cookie";
import { configure } from "axios-hooks";
import LRU from "lru-cache";

const cookies = new Cookies();

export const InterceptContext = createContext();

export const api = axios.create({
  baseURL: `${url}`,
});

export const InterceptProvider = ({ children }) => {
  api.interceptors.request.use(
    async (config) => {
      // const token = sessionStorage.getItem('token')
      const token = cookies.get("token");
      if (token) {
        config.headers.Authorization = `Token ${token}`;
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error && error.response && error.response.status) {
        if (error.response.status === 401) {
          // moze wykorzysta to sie potem
          // logout();
        }
      }
      return Promise.reject(error);
    }
  );

  return <InterceptContext.Provider>{children}</InterceptContext.Provider>;
};
